function rootURL(endpoint) {
  if (endpoint.indexOf("://") > 0) {
    return endpoint;
  }

  if (process.env.NODE_ENV !== "production" && process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL + endpoint;
  }

  return endpoint;
}

export default rootURL;
